{
  "name": "axiom",
  "version": "0.37.0",
  "type": "module",
  "author": "Axiom, Inc.",
  "contributors": [
    "Islam Shehata <islam@axiom.co>",
    "Chris Ehrlich <chris@axiom.co>",
    "Gabriel de Andrade <gabriel@axiom.co>"
  ],
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup && chmod +x dist/bin.js",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "lint": "eslint './**/*.{js,ts}'",
    "typecheck": "tsc --noEmit",
    "test": "vitest run",
    "test:watch": "vitest --watch",
    "publint": "npx publint"
  },
  "types": "./dist/index.d.ts",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "bin": {
    "axiom": "./dist/bin.js"
  },
  "exports": {
    "./ai": {
      "import": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      },
      "require": {
        "types": "./dist/index.d.cts",
        "default": "./dist/index.cjs"
      }
    },
    "./ai/evals": {
      "import": {
        "types": "./dist/evals.d.ts",
        "default": "./dist/evals.js"
      },
      "require": {
        "types": "./dist/evals.d.cts",
        "default": "./dist/evals.cjs"
      }
    },
    "./ai/config": {
      "import": {
        "types": "./dist/config.d.ts",
        "default": "./dist/config.js"
      },
      "require": {
        "types": "./dist/config.d.cts",
        "default": "./dist/config.cjs"
      }
    },
    "./ai/feedback": {
      "import": {
        "types": "./dist/feedback.d.ts",
        "default": "./dist/feedback.js"
      },
      "require": {
        "types": "./dist/feedback.d.cts",
        "default": "./dist/feedback.cjs"
      }
    }
  },
  "keywords": [
    "axiom",
    "logging",
    "ai",
    "otel",
    "opentelemetry"
  ],
  "repository": {
    "type": "git",
    "url": "git+https://github.com/axiomhq/ai.git",
    "directory": "packages/ai"
  },
  "license": "MIT",
  "dependencies": {
    "@next/env": "^15.4.2",
    "@opentelemetry/auto-instrumentations-node": "^0.60.1",
    "@opentelemetry/context-async-hooks": "^2.0.1",
    "@opentelemetry/exporter-trace-otlp-http": "^0.202.0",
    "@opentelemetry/resources": "^2.0.1",
    "@opentelemetry/sdk-trace-node": "^2.0.1",
    "@opentelemetry/semantic-conventions": "^1.37.0",
    "@sinclair/typebox": "^0.34.37",
    "c12": "^2.0.4",
    "commander": "^14.0.0",
    "defu": "^6.1.4",
    "handlebars": "^4.7.8",
    "nanoid": "^5.1.5",
    "open": "^10.1.0",
    "vite-tsconfig-paths": "^5.1.4",
    "vitest": "^4.0.0"
  },
  "peerDependencies": {
    "@opentelemetry/api": "^1.9.0",
    "zod": "^3.25.0 || ^4.0.0"
  },
  "devDependencies": {
    "@ai-sdk/anthropicv1": "npm:@ai-sdk/anthropic@^1.2.12",
    "@ai-sdk/anthropicv2": "npm:@ai-sdk/anthropic@^2.0.44",
    "@ai-sdk/openaiv1": "npm:@ai-sdk/openai@^1.3.24",
    "@ai-sdk/openaiv2": "npm:@ai-sdk/openai@^2.0.67",
    "@ai-sdk/providerv1": "npm:@ai-sdk/provider@^1.1.3",
    "@ai-sdk/providerv2": "npm:@ai-sdk/provider@^2.0.0",
    "@opentelemetry/api": "^1.9.0",
    "@opentelemetry/core": "^2.0.1",
    "@opentelemetry/sdk-trace-base": "^2.0.1",
    "@opentelemetry/sdk-trace-node": "^2.0.1",
    "@repo/eslint-config": "workspace:*",
    "@types/node": "^22.15.29",
    "@vitest/coverage-v8": "^4.0.0",
    "aiv4": "npm:ai@^4.3.19",
    "aiv5": "npm:ai@^5.0.93",
    "esbuild": "^0.25.8",
    "eslint": "catalog:",
    "msw": "^2.12.2",
    "prettier": "catalog:",
    "tinyrainbow": "^2.0.0",
    "tsup": "catalog:",
    "typescript": "catalog:",
    "vitest": "catalog:",
    "zod": "catalog:"
  },
  "files": [
    "dist"
  ],
  "packageManager": "pnpm@10.16.1"
}
